/* Complete collections keep component book variants as separate Shopify lines. */
(function (global) {
  const MAX_LINES = 200;
  function buildLines(selections, plans, releaseMap) {
    if (!Array.isArray(selections) || !selections.length) throw new Error('Choose a collection first.');
    const lines = new Map();
    for (const [id, sets] of selections) {
      const plan = plans.find(p => p.id === id);
      if (!plan || !Number.isSafeInteger(sets) || sets < 1 || sets > 10000) throw new Error('Check your collection quantities.');
      if (plan.titles.length !== plan.count || new Set(plan.titles.map(t => t.id)).size !== plan.count) throw new Error('This collection needs a contents review. Please request a quote.');
      for (const title of plan.titles) {
        const book = releaseMap[title.id];
        if (!book || !Number.isSafeInteger(book.variantId) || !book.handle) throw new Error('This collection needs an availability check. Please request a quote.');
        const previous = lines.get(book.variantId);
        const quantity = (previous?.quantity || 0) + sets;
        if (!Number.isSafeInteger(quantity) || quantity > 10000) throw new Error('For this quantity, please request a quote.');
        lines.set(book.variantId, { id: book.variantId, quantity, handle: book.handle, releaseApproved: book.releaseApproved === true });
      }
    }
    const result = [...lines.values()];
    if (result.length > MAX_LINES) throw new Error('This master library is best handled as a personal quote.');
    if (result.some(line => !line.releaseApproved)) throw new Error('These books are still in development. Request a quote now; checkout opens after release.');
    return result;
  }
  async function verifyLines(lines, readProduct) {
    // Bound concurrency and verify the selected variant in the current country.
    let cursor = 0;
    await Promise.all(Array.from({ length: Math.min(6, lines.length) }, async () => {
      while (cursor < lines.length) {
        const line = lines[cursor++];
        const product = await readProduct(line.handle);
        const variant = product.variants?.find(v => Number(v.id) === line.id);
        if (!variant?.available || !(variant.price > 0)) throw new Error('A book in your selection is unavailable in this market. Please request a quote.');
      }
    }));
    return lines.map(({ id, quantity }) => ({ id, quantity }));
  }
  global.MoharniCollectionCart = { buildLines, verifyLines, MAX_LINES };
  if (typeof document === 'undefined') return;
  document.addEventListener('DOMContentLoaded', () => {
    const checkout = document.querySelector('.bag-checkout');
    const status = document.querySelector('#collection-checkout-status');
    const quote = document.querySelector('#bag-quote');
    if (!checkout || !status || !quote) return;
    const root = global.Shopify?.routes?.root || '/';
    let busy = false;
    const renderBefore = renderBag;
    renderBag = function () {
      renderBefore();
      quote.disabled = busy || bagItems.size === 0;
      try {
        buildLines([...bagItems], collectionPlans, global.MoharniReleaseMap || {});
        checkout.disabled = busy;
        checkout.textContent = busy ? 'Adding books…' : 'Add complete selection to cart →';
        status.textContent = 'Every included book will appear in your Shopify cart. Shipping and taxes are calculated at checkout; overlapping collections add extra copies.';
      } catch (error) {
        checkout.disabled = true;
        checkout.textContent = 'Checkout opens after release';
        status.textContent = error.message;
      }
    };
    quote.addEventListener('click', () => {
      const quantities = new Map();
      const selections = [];
      for (const [id, sets] of bagItems) {
        const plan = collectionPlans.find(p => p.id === id);
        if (!plan) continue;
        selections.push(`${sets} × ${plan.name}`);
        for (const title of plan.titles) {
          const item = quantities.get(title.id) || { title: title.title, quantity: 0 };
          item.quantity += sets;
          quantities.set(title.id, item);
        }
      }
      collectionSelect.value = 'custom';
      quantityInput.value = 1;
      updatePlan();
      preparedPlan = '';
      document.querySelector('#custom').value = [...quantities].map(([sku, item]) => `${item.quantity} copies · ${item.title} (${sku})`).join('\n');
      planForm.elements.notes.value = 'Selected complete collections:\n' + selections.join('\n') + '\nOverlapping collections include additional copies; please confirm quantities in the quote.';
      collectionBag.close();
      document.querySelector('#groups').scrollIntoView({ behavior: 'smooth' });
      planForm.elements.name.focus({ preventScroll: true });
    });
    checkout.addEventListener('click', async () => {
      if (busy) return;
      busy = true;
      renderBag();
      let submitted = false;
      try {
        const lines = buildLines([...bagItems], collectionPlans, global.MoharniReleaseMap || {});
        const items = await verifyLines(lines, async handle => {
          const response = await fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' });
          if (!response.ok) throw new Error('A book is unavailable. Please request a quote.');
          return response.json();
        });
        submitted = true;
        const response = await fetch(root + 'cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items }) });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || 'Please review your cart before trying again.');
        bagItems.clear();
        renderBag();
        global.location.assign(root + 'cart');
      } catch (error) {
        status.textContent = submitted ? error.message + ' Check your cart before retrying; your selection has been kept.' : error.message;
        if (submitted) {
          const link = document.createElement('a');
          link.href = root + 'cart'; link.textContent = 'Review your cart →';
          status.append(' ', link);
        }
      } finally { busy = false; let ready = false; try { buildLines([...bagItems], collectionPlans, global.MoharniReleaseMap || {}); ready = true; } catch (_) {} checkout.disabled = submitted || !ready; quote.disabled = bagItems.size === 0; }
    });
    renderBag();
    const result = document.querySelector('#quote-result');
    if (result?.textContent.trim()) { result.scrollIntoView({ block: 'center' }); result.focus(); }
  });
})(typeof window === 'undefined' ? globalThis : window);
